import { Injectable } from "@angular/core";
import { IndElement } from "@shared/models/cat.model";
import { RevRule } from "@shared/models/rev.model";
import { Subject } from "rxjs";
import { CommonService } from "./common.service";
import { AppState } from "@shared/redux/store";
import { NgRedux } from "@shared/redux/redux-compatibility.service";


@Injectable({
  providedIn: 'root'
})
export class PropagateActionsFromParentService {

    private revRulesToUpdate: RevRule[] = [];

    private elementsToUpdate: IndElement[] = [];

    private childrenSelectionCancel$ = new Subject<void>();

    constructor(private commonService: CommonService, private ngRedux: NgRedux<AppState>) {}

    clear() {
    
        this.revRulesToUpdate = [];
        this.elementsToUpdate = [];
    }

    addRevRule(element: RevRule) {
        
        this.revRulesToUpdate.push(element);
    }
    getRevRulesToUpdate() {
        return this.revRulesToUpdate;
    }
    addIndElement(element: IndElement) {
        this.elementsToUpdate.push(element);
    }
    
    getIndElementsToUpdate() {
        return this.elementsToUpdate;
    }
    

}